/**
 * 呼び出し元画面の入力情報を格納するVO
 *
 * @export KYMW0700InputModel
 * @class KYMW0700InputModel
 */
export class KYMW0700InputModel {
  /** 画面ＩＤ */
  public formId: string = <string>'';
  /** Pコード */
  public goodsCode: string = <string>'';
  /** 商品文字情報種別 */
  public textKindId: string = <string>'';
  /** 商品名 */
  public goodsName: string = <string>'';
  /** 規格名 */
  public guideGoodsName: string = <string>'';
}

